module.exports = __webpack_public_path__ + "static/media/4.e98eaea1.jpg";